import { useQuery } from '@tanstack/react-query';
import { RolesApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useRolesControllerFindRoleByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['rolesControllerFindRoleById', accessControlScope, args],
        queryFn: async () => {
            const api = new RolesApi(accessControlConfig);
            return api.rolesControllerFindRoleById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useRolesControllerFindRoleByIdQuery.js.map